import React from "react";
import { styled } from "@mui/material/styles";
import { Button, CircularProgress } from "@mui/material";

const StyledButton = styled(Button)(({ theme, MT, border }) => ({
  marginTop: `${MT ? MT + "px" : "40px"}`,
  width: "100%",
  fontFamily: theme.typography.fontFamily,
  backgroundColor: `${
    border ? theme.palette.background.white : theme.palette.main
  }`,
  border: `${border ? "1px solid" + theme.palette.colors.BlackBean : "none"}`,
  color: `${border ? theme.palette.colors.BlackBean : "#fff"}`,
  borderRadius: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "25px",
  textAlign: "center",
  height: "50px",
  textTransform: "capitalize",
  "&:hover": {
    background: "rgb(51, 51, 51)",
    color: "#fff",
  },
  "&:disabled": {
    border: "none",
  },
  "& span.MuiCircularProgress-root": {
    color: "#000",
  },
}));

const MainButton = ({
  onClick,
  label,
  variant,
  color,
  disabled,
  type,
  isLoading,
  MT,
  border,
}) => {
  return (
    <StyledButton
      onClick={onClick}
      variant={variant}
      color={color}
      disabled={disabled || isLoading}
      type={type}
      MT={MT}
      border={border}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : label}
    </StyledButton>
  );
};

MainButton.defaultProps = {
  label: "Submit",
  variant: "contained",
  color: "primary",
  disabled: false,
  type: "button",
  onClick: () => {},
  isLoading: false,
  MT: "",
  border: false,
};

export default MainButton;
